import React, { useEffect, useContext } from "react";
import { useHistory } from "react-router-dom";
import { MainHeader, Navigation } from "../components";

export const TermsLayout = (props) => {
  const history = useHistory();
  const { children } = props;

  return (
    <div className="terms-layout">
      <section className="content__container">
        <section className="content__box">
          <article className="scroll__container">{children}</article>
        </section>
      </section>
    </div>
  );
};
